import { useTranslation } from "@equiem/web-ng-lib";
import React from "react";
import { DealTag } from "../../store/products/DealTag";
import { SearchNode } from "./SearchEdge";
import { SearchResult } from "./SearchResult";
import { FaStore } from "react-icons/fa";

interface Props {
  product: SearchNode<"DealContentEdge">;
}

export const DealProductSearchResult: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();

  return (
    <SearchResult
      href="/store/deal/[uuid]"
      as={`/store/deal/${product.uuid}`}
      title={product.name}
      body={product.excerpt}
      imageUrl={product.image ?? undefined}
      imageSuffix={product.showOverlay ? <DealTag /> : undefined}
      footer={
        <div className="mt-auto">
          <div className="vendor-name pb-2 d-flex align-items-center">
            <FaStore /> <span className="ml-2">{product.vendor.name}</span>
          </div>
          {product.showOverlay ? t("main.deal") : null}
        </div>
      }
    />
  );
};
